import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: [],
    adminDetails: [],
    clientBrands: null,
    remindEmail: null,
    openDrawer: false,
  },
  reducers: {
    updateUserDetails: (state, action) => {
      state.user = action.payload;
    },
    updateAdminDetails: (state, action) => {
      state.adminDetails = action.payload;
    },
    updateClientBrands: (state, action) => {
      state.clientBrands = action.payload;
    },
    clearUserDetails: (state) => {
      state.user = [];
    },
    updateReminderEmail: (state, action) => {
      state.remindEmail = action.payload;
    },
    updateDrawer: (state, action) => {
      state.openDrawer = !state.openDrawer;
    },
  },
});

export const {
  updateUserDetails,
  clearUserDetails,
  updateAdminDetails,
  updateClientBrands,
  updateReminderEmail,
  updateDrawer,
} = userSlice.actions;
export default userSlice.reducer;
